import * as React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

export default class SelectFieldCountryCode extends React.Component<any> {

  render() {
    return (
      <SelectFieldContainer>
        <Field as="select" {...this.props}>
          {this.props.children}
        </Field>
        <p><i className="arrow down" /></p>
      </SelectFieldContainer>
    );
  }
}
export const SelectFieldContainer = styled.div`
	margin: 0;
	width: 5em;
	border-color: #E3DFDE;
  p {
    float: right;
    margin: -2em -3.5625em 0 0;

    i {
      border: solid black;
      border-width: 0 0.125em 0.125em 0;
      display: inline-block;
      padding: 0.1875em;
    }

    .down {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
  }`;
